
import { takeLatest, put, call } from 'redux-saga/effects';
import * as CaseListActions from './Actions';
import {DOWNLOAD_PENDING_CASES,
    downloadPendingCasesSuccess,
    downloadPendingCasesFailure
} from './Actions';
import { CORE_API } from '../../../config';
import { HTTP_HEADERS, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import request from '../../../components/Utils/httpHelper';

export function* caseList(action) {
    let sortDir = (action.data.pageDescription.sorted.desc) ? "desc" : "asc";
    let requestUrl = `${CORE_API}/case/type/${action.data.pageDescription.status}/${action.data.pageDescription.pageNo}/${action.data.pageDescription.pageSize}/sort/${action.data.pageDescription.sorted.id}/${sortDir}`;
    try {
        const listResult = yield call(request, requestUrl, { data: action.data.requestBody, method: 'POST', headers: HTTP_HEADERS });
        yield put(CaseListActions.viewPaginatedCasesSuccess(listResult));
    } catch (err) {
        yield put(CaseListActions.viewPaginatedCasesFail(err))
    }
}
export function* fetchCaseList() {
    yield takeLatest(CaseListActions.VIEW_PAGINATED_CASES, caseList);
}

export function* fetchPendingCasesDownloadData(action) {
    let requestUrl = `${CORE_API}/case/type/PENDING/0/0/sort/null/null`;
    try {
        const listResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: { 'Content-Type': 'application/json' }, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadPendingCasesSuccess(listResult));
    } catch (err) {
        yield put(downloadPendingCasesFailure(err))
    }
}

export function* downloadPendingCases() {
    yield takeLatest(DOWNLOAD_PENDING_CASES, fetchPendingCasesDownloadData);
}

export function* corporateList(action) {
    let requestUrl = `${CORE_API}/corporate/filtermodel/list`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CaseListActions.getCorporateNameSuccess(listResult.data));
    } catch (err) {
        yield put(CaseListActions.getCorporateNameFailure(err.response))
    }
}
export function* fetchCorporateName() {
    yield takeLatest(CaseListActions.FETCH_CORPORATE_NAME, corporateList);
}

export function* productsByCorporates(action) {
    let requestUrl = `${CORE_API}/product/list/corporates`;
    try {
        const productResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        let productsArray = Array.isArray(productResult) ? productResult : (productResult && productResult.data ? productResult.data : []);
        
        const productOptions = Array.isArray(productsArray) ? productsArray.map(product => {
            const mapped = {
                value: product._id || product.id,
                label: product.productName || product.name
            };
            return mapped;
        }) : []       
        yield put(CaseListActions.fetchProductsByCorporatesSuccess(productOptions));
    } catch (err) {
        yield put(CaseListActions.fetchProductsByCorporatesFailure(err.response))
    }
}
export function* fetchProductsByCorporatesWatcher() {
    yield takeLatest(CaseListActions.FETCH_PRODUCTS_BY_CORPORATES, productsByCorporates);
}

/* export function* dataAutomation(action) {
    let requestUrl = `${REPORT}/crawler/initiate`;
    try {
        const result = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(CaseListActions.dataAtuomationInitiateSuccess(result.data));
    } catch (err) {
        yield put(CaseListActions.dataAtuomationInitiateFailure(err.response))
    }
}
export function* dataAutomationInitiate() {
    yield takeLatest(CaseListActions.DATA_AUTOMATION_INITIATE, dataAutomation);
} */

// export function* epfDetails(action) {
//     if(action.data && action.data !== null) {
//     let requestUrl = `${CORE_API}/crawler/epfData/${action.data}`;
//     try {
//         const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
//         yield put(CaseListActions.caseDetailsEPFSuccess(listResult));
//     } catch (err) {
//         yield put(CaseListActions.caseDetailsEPFFailure(err))
//     }
// }
// }
// export function* fetchCaseEPFDetails() {
//     yield takeLatest(CaseListActions.GET_CASE_EPF_DETAILS, epfDetails);
// }